// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import legalCasePartyEntity from './entities/legal-case-party.json';
import legalCasePartyMenu from '../pages/legal-case-party/menu.json';
import legalCasePartyFullForm from '../pages/legal-case-party/forms/full.json';
import legalCasePartyContextForm from '../pages/legal-case-party/forms/context.json';
import legalCasePartyMiniForm from '../pages/legal-case-party/forms/mini.json';
import legalCasePartyLookupForm from '../pages/legal-case-party/forms/lookup.json';
import legalCasePartyTableView from '../pages/legal-case-party/views/table.json';
import legalCasePartyCardsView from '../pages/legal-case-party/views/cards.json';
import legalCasePartyDashboardView from '../pages/legal-case-party/views/dashboard.json';

/** Тип запису «Сторона справи» зі сторінками пакета: меню, форми та подання з pages/legal-case-party/. */
export const legalCasePartyDefinition: IRecordTypeDefinition = {
  ...legalCasePartyEntity,
  views: assembleViewSet({
      table: legalCasePartyTableView,
      cards: legalCasePartyCardsView,
      dashboard: legalCasePartyDashboardView,
  }),
  form: legalCasePartyFullForm,
  forms: { full: legalCasePartyFullForm, context: legalCasePartyContextForm, mini: legalCasePartyMiniForm, lookup: legalCasePartyLookupForm },
  menu: legalCasePartyMenu,
} as IRecordTypeDefinition;
